import React, { useState, useEffect } from "react";
import ClassNames from "classnames";
import styles from "./index.module.scss";
import {
  endOfToday,
  firstDateOfYear,
  localToUTC,
  addMaxSecondsToTime,
} from "../../utils/datetime";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

export default function DateRangePicker({
  handleDateChange,
  dateSelectionRestriction = true,
  disabled,
  filterDate,
  ...props
}) {
  const [startDate, setStartDate] = useState(firstDateOfYear());
  const [endDate, setEndDate] = useState(endOfToday());
  const handleStartDateChange = val => {
    setStartDate(localToUTC(val));
  };
  const handleEndDateChange = val => {
    setEndDate(addMaxSecondsToTime(localToUTC(val)));
  };

  useEffect(() => {
    if (
      props.selectedDateRange &&
      props.selectedDateRange.startDate &&
      props.selectedDateRange.endDate
    ) {
      setStartDate(localToUTC(props.selectedDateRange.startDate));
      setEndDate(localToUTC(props.selectedDateRange.endDate));
    }
  }, []);

  useEffect(() => {
    handleDateChange({
      startDate: localToUTC(startDate),
      endDate: localToUTC(endDate),
    });
  }, [startDate, endDate]);
  
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={ClassNames(styles.pickerGroup, props.className)}>
        <div className={styles.datePickerContainer}>
          <CalendarTodayIcon className={styles.pickerIcon} fontSize="inherit" />
          <DatePicker
            disableToolbar
            variant="inline"
            disablePast={props.disablePast}
            disableFuture={props.disableFuture}
            className={styles.datePicker}
            format="dd/M/yyyy"
            autoOk={true}
            onChange={handleStartDateChange}
            value={startDate}
            animateYearScrolling
            disabled={disabled}
          />{" "}
          -
          <DatePicker
            disableToolbar
            variant="inline"
            disablePast={props.disablePast}
            className={`${styles.datePicker} ${styles.second}`}
            format="dd/M/yyyy"
            onChange={handleEndDateChange}
            value={endDate}
            autoOk={true}
            animateYearScrolling
            minDate={
              dateSelectionRestriction
                ? localToUTC(startDate).add(2, "day")
                : localToUTC(startDate)
            }
            disabled={disabled}
          />
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
}
